import { render, staticRenderFns } from "./DeliveryNoteListView.vue?vue&type=template&id=c819673e&"
import script from "./DeliveryNoteListView.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoteListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports